import React from "react";

function Header() {
  const storedUser =
    localStorage.getItem("user") ||
    localStorage.getItem("localUser");

  let user = null;

  try {
    user = storedUser ? JSON.parse(storedUser) : null;
  } catch (error) {
    console.error("Failed to parse user information:", error);
  }

  const organizationName =
    user?.organization_name || "Organization";

  return (
    <header className="app-header">
      <div className="app-header-company">
        {organizationName}
      </div>
    </header>
  );
}

export default Header;